export const PUBLIC_FORMS_PATH = '/reports/forms';
export const LEGACY_PUBLIC_FORMS_PATH = '/public-forms';

const PUBLIC_FORMS_ACCESS_LEVELS = new Set(['user', 'admin', 'global admin']);

export const canAccessPublicForms = (accessLevel) => (
  typeof accessLevel === 'string'
  && PUBLIC_FORMS_ACCESS_LEVELS.has(accessLevel.trim().toLowerCase())
);

export const publicFormsFallbackPath = (accessLevel) => (
  typeof accessLevel === 'string' && accessLevel.trim().toLowerCase() === 'storms'
    ? '/dashboard/weather'
    : '/dashboard'
);
